import { string, array, object, number, boolean } from 'yup';

export const validationSchema = {
  textAudio: string().required('required field'),
  textAudioKey: string().required(),
  rowSize: number()
    .typeError('required field')
    .min(3, 'Row size must be between 3 and 4')
    .max(4, 'Row size must be between 3 and 4')
    .required('required field'),
  options: array().of(
    object().shape({
      id: number().required(),
      option: string().required('required field'),
      showValue: boolean().required('required field'),
    })
  ),
};
